import { createSlice } from "@reduxjs/toolkit"

import { fetchLoans } from "../api/api"


const initialState={
   loading:false,
   error:{}, 
   loans: null

}

const getLoansSlice= createSlice({
    name:'getLoans',
     initialState,

     reducers:{

     },

     extraReducers: (builder)=>{
        builder.addCase( fetchLoans.pending, (state)=>{
            state.loading = true
            state.error={}
            state.loans =null

        })

        builder.addCase( fetchLoans.rejected, (state, action)=>{
            state.loading=false
            state.error= action.payload
            state.loans=null
        }

        )
        builder.addCase( fetchLoans.fulfilled, (state, action)=>{
            state.loading=false
            state.error={}
            state.loans= action.payload
        }
            )


     }

})

export default getLoansSlice.reducer